import React from 'react'
import Menu from '@mui/material/Menu'
import { Chip, Tooltip } from '@mui/material'
import { cn } from '../../lib/utils'
import { useNavigate } from 'react-router'
import * as RoutePaths from '../../Entities/RoutePath'
import * as MainContainerEntity from '../../Entities/MainContainerTypes'
import { IoMdHelpCircleOutline } from 'react-icons/io'
import { get, useLoginStore } from 'src/Containers/Auth/Store/Store'
import { IoReload } from 'react-icons/io5'
import { LOGIN_EMAIL, LOGTYPE, PARAMS, REFERRER } from 'src/Entities/AuthEntities'
import { LogUserLoginApi } from 'src/API/LoginAPI'
import { useCommonStore } from 'src/Common/store/CommonStore'

const Profile = ({ ProfileAnchor, setProfileAnchor }) => {
    const { logout } = useLoginStore()
    const hasOrgs = useCommonStore(state => state.hasOrgs)

    const open = Boolean(ProfileAnchor)
    const userName = get('userName')
    // const userRoles = get('userRoles')
    const emailId = get('emailId')
    const profilePic = get('profilePic')
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))

    const handleClose = () => {
        setProfileAnchor(null)
    }

    const getInitial = name => {
        const [ firstName, lastName ] = name?.split(' ')

        if (firstName && lastName) {
            return `${firstName?.charAt(0)}${lastName?.charAt(0)}`?.toUpperCase()
        }
        return firstName?.charAt(0)?.toUpperCase()
    }

    const navigate = useNavigate()
    const handleSwitch = () => {
        const email = get(PARAMS.EMAIL)
        if (email) {
            navigate(RoutePaths.SELECT_ORG.URI + '?' + LOGIN_EMAIL + '=' + email + '&' + REFERRER + '=')
        }
    }
    const handleNavigate = () => {
        setProfileAnchor(null)
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI, MainContainerEntity.MENU_TYPE_SETTINGS)
    }
    const handleNavigateHelpPage = () => {
        setProfileAnchor(null)
        navigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.HELP_CENTER.URI, MainContainerEntity.MENU_TYPE_HELP_CENTER)
    }
    const Logout = () => {
        const paramData = {
            [PARAMS.ORGID]: get(PARAMS.ORGID),
            [PARAMS.EMAIL]: get(PARAMS.EMAIL),
            [PARAMS.USER_ID]: get(PARAMS.USER_ID),
            [PARAMS.TYPE]: LOGTYPE.LOGOUT
        }
        LogUserLoginApi(paramData)
        setProfileAnchor(null)
        setTimeout(() => {
            logout()
        }, 500)
    }
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    return (
        <div>
            <Menu
                anchorEl={ProfileAnchor}
                id="account-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        overflow: 'visible',
                        // height: '60%',
                        borderRadius: '10px',
                        marginTop: '6px',
                        p: 0,
                        '& .MuiList-root': {
                            height: '100%',
                            padding: '0px'
                        }
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <div className='w-[371px] h-[100%]'>
                    <div className='w-[100%] h-[100%]'>
                        <div className={cn('flex flex-row w-[100%] p-5 gap-2 justify-start items-center')}>
                            {/* <Avatar src={profilePic} style={{ height: '48px', width: '48px' }} alt={userName?.split('Mr.')[1] || userName?.split('Mrs.')[1] || userName?.split('Ms.')[1] || userName?.split('Mx.')[1] || userName?.split('Dr.')[1] || userName} /> */}
                            <div
                                aria-label={name}
                                role="img"
                                className={'initials-avatar'}
                            >
                                {((!profilePic))
                                    ? <div>{getInitial(userName || 'John Rampo')}</div>
                                    : <img style={{ width: '100%', height: '100%', borderRadius: '50%' }} src={profilePic} />}
                            </div>
                            <div >
                                <p className='text-[18px] font-[600] text-primary'>{userName}</p>
                                <p className='text-[14px]'>{emailId}</p>
                            </div>
                        </div>
                        {!isAdmin && <div className='flex px-5 pb-5 gap-2 border-b-2 border-b-input items-start'>
                            <p className='font-[500] text-[18px] text-primary'>Role</p>
                            <p className='flex gap-2 flex-wrap font-semibold text-primary'>
                                {Object.values(userRoles || [])?.map((item, ind) => {
                                    const checkRoleCategory = (roleDt) => {
                                        if (roleDt?.includes('Governance')) {
                                            return 'Governance'
                                        }
                                        if (roleDt?.includes('Risk')) {
                                            return 'Risk'
                                        }
                                        if (roleDt?.includes('Compliance')) {
                                            return 'Compliance'
                                        }
                                    }
                                    return <div key={ind} className="whitespace-nowrap overflow-hidden overflow-ellipsi">
                                        {item.length > 12
                                            ? (
                                                <Tooltip title={item} placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                    <Chip style={{ margin: '2px 0px', cursor: 'pointer', fontWeight: 300, fontSize: '14px', height: '27px', color: 'hsl(var(--card))', backgroundColor: `hsl(var(--${checkRoleCategory(item)}))` }} label={item} />
                                                </Tooltip>
                                            )
                                            : (
                                                <Chip style={{ margin: '2px 0px', fontWeight: 300, fontSize: '14px', height: '27px', color: 'hsl(var(--card))', cursor: 'pointer', backgroundColor: `hsl(var(--${checkRoleCategory(item)}))` }}label={item}/>
                                            )}
                                    </div>
                                })}
                            </p>
                        </div>}
                        <div onClick={() => handleNavigate()} className={cn('flex cursor-pointer flex-row w-[100%] border-t-2 border-[#8883] border-b-input p-4 gap-6 items-center')}>
                            <img src='/Common/Icon/ProfileIconGreen.svg'/>
                            <p className='text-lg font-[500]'>Profile</p>
                        </div>
                        {!isAdmin && hasOrgs && <div onClick={() => handleSwitch()} className={cn('flex cursor-pointer flex-row w-[100%] border-t-2 border-[#8883] border-b-input p-4 gap-6 items-center')}>
                            <IoReload className='lg:w-8 lg:h-8 text-primary' />
                            <p className='text-lg font-[500]'>Switch Organization</p>
                        </div>}
                        <div onClick={() => handleNavigateHelpPage()} className={cn('flex cursor-pointer flex-row w-[100%] border-t-2 border-[#8883] border-b-input p-4 gap-6 items-center')}>
                            <IoMdHelpCircleOutline className='lg:w-8 lg:h-8  text-primary' />
                            <p className='text-lg font-[500]'>Help Center</p>
                        </div>
                        <div onClick={Logout} className={cn('flex flex-row w-[100%] border-[#8883] border-t-2 border-b-input cursor-pointer p-4 gap-6 items-center')}>
                            <img src='/Common/Icon/logoutIconRed.svg'/>
                            <p className='text-lg font-[500]'>Logout</p>
                        </div>
                    </div>
                </div>
            </Menu>
        </div>
    )
}

export default Profile
